// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Tooltip_text-gradient__2r1Vd","tooltip":"Tooltip_tooltip__3760D","tooltipRight":"Tooltip_tooltipRight__ur9Ex","tooltipHeader":"Tooltip_tooltipHeader__2j714"};